import "./styles.css";
import "./styles.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import React, { useContext, useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { FaBars } from "react-icons/fa";

import { Footer, Sidebar } from "./components";
import { Fallback } from "./components/Fallback";
import { AuthContext } from "./contexts/AuthContext";
import { useStateContext } from "./contexts/ContextProvider";
import Login from "./pages/Login/Login";
import DaftarUser from "./pages/Utility/DaftarUser/DaftarUser";
import TambahUser from "./pages/Utility/DaftarUser/TambahUser";
import UbahUser from "./pages/Utility/DaftarUser/UbahUser";
import TampilKategori from "./pages/Master/Kategori/TampilKategori";
import TambahKategori from "./pages/Master/Kategori/TambahKategori";
import UbahKategori from "./pages/Master/Kategori/UbahKategori";
import TampilMerk from "./pages/Master/Merk/TampilMerk";
import TambahMerk from "./pages/Master/Merk/TambahMerk";
import UbahMerk from "./pages/Master/Merk/UbahMerk";
import TampilBarang from "./pages/Master/Barang/TampilBarang";
import TambahBarang from "./pages/Master/Barang/TambahBarang";
import UbahBarang from "./pages/Master/Barang/UbahBarang";
import TampilAdminWhatsapp from "./pages/Master/AdminWhatsapp/TampilAdminWhatsapp";
import TampilInformasiToko from "./pages/Master/InformasiToko/TampilInformasiToko";
import TampilKeranjang from "./pages/Transaksi/Keranjang/TampilKeranjang";
import TampilPesanan from "./pages/Transaksi/Pesanan/TampilPesanan";

const App = () => {
  const { setScreenSize } = useStateContext();
  const { user } = useContext(AuthContext);
  const [collapsed, setCollapsed] = useState(false);
  const [toggled, setToggled] = useState(false);

  const ProtectedRoute = ({ menuAccess, children }) => {
    if (!user) return <Navigate to="/" />;
    if (user.akses?.[menuAccess]) return children;
    return <Navigate to="/unauthorized" />;
  };

  const defaultRoute = user?.akses?.kategori
    ? "/kategori"
    : user?.akses?.merk
      ? "/merk"
      : user?.akses?.barang
        ? "/barang"
        : user?.akses?.adminWhatsapp
          ? "/adminWhatsapp"
          : user?.akses?.informasiToko
            ? "/informasiToko"
            : user?.akses?.keranjang
              ? "/keranjang"
              : user?.akses?.pesanan
                ? "/pesanan"
                : user?.akses?.daftarUser
                  ? "/daftarUser"
                  : "/unauthorized";

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [setScreenSize]);

  if (!user) {
    return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    );
  }

  return (
    <div className="app-shell">
      <Sidebar
        collapsed={collapsed}
        toggled={toggled}
        handleToggleSidebar={setToggled}
        handleCollapsedChange={() => setCollapsed(!collapsed)}
      />
      <main className="app-main">
        <button
          className="mobile-menu-btn"
          type="button"
          onClick={() => setToggled(true)}
          aria-label="Buka menu"
        >
          <FaBars />
        </button>
        <section className="content-shell">
          <ErrorBoundary FallbackComponent={Fallback}>
            <Routes>
              <Route path="/" element={<Navigate to={defaultRoute} />} />
              <Route
                path="/kategori"
                element={
                  <ProtectedRoute menuAccess="kategori">
                    <TampilKategori />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kategori/:id"
                element={
                  <ProtectedRoute menuAccess="kategori">
                    <TampilKategori />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kategori/tambahKategori"
                element={
                  <ProtectedRoute menuAccess="kategori">
                    <TambahKategori />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kategori/:id/edit"
                element={
                  <ProtectedRoute menuAccess="kategori">
                    <UbahKategori />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/merk"
                element={
                  <ProtectedRoute menuAccess="merk">
                    <TampilMerk />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/merk/:id"
                element={
                  <ProtectedRoute menuAccess="merk">
                    <TampilMerk />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/merk/tambahMerk"
                element={
                  <ProtectedRoute menuAccess="merk">
                    <TambahMerk />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/merk/:id/edit"
                element={
                  <ProtectedRoute menuAccess="merk">
                    <UbahMerk />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/barang"
                element={
                  <ProtectedRoute menuAccess="barang">
                    <TampilBarang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/barang/:id"
                element={
                  <ProtectedRoute menuAccess="barang">
                    <TampilBarang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/barang/tambahBarang"
                element={
                  <ProtectedRoute menuAccess="barang">
                    <TambahBarang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/barang/:id/edit"
                element={
                  <ProtectedRoute menuAccess="barang">
                    <UbahBarang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/adminWhatsapp"
                element={
                  <ProtectedRoute menuAccess="adminWhatsapp">
                    <TampilAdminWhatsapp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/informasiToko"
                element={
                  <ProtectedRoute menuAccess="informasiToko">
                    <TampilInformasiToko />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/keranjang"
                element={
                  <ProtectedRoute menuAccess="keranjang">
                    <TampilKeranjang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/keranjang/:id"
                element={
                  <ProtectedRoute menuAccess="keranjang">
                    <TampilKeranjang />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pesanan"
                element={
                  <ProtectedRoute menuAccess="pesanan">
                    <TampilPesanan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/pesanan/:id"
                element={
                  <ProtectedRoute menuAccess="pesanan">
                    <TampilPesanan />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <DaftarUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/:id"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <DaftarUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/tambahUser"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <TambahUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/daftarUser/:id/edit"
                element={
                  <ProtectedRoute menuAccess="daftarUser">
                    <UbahUser />
                  </ProtectedRoute>
                }
              />
              <Route path="/unauthorized" element={<p>Unauthorized</p>} />
              <Route path="*" element={<Navigate to={defaultRoute} />} />
            </Routes>
          </ErrorBoundary>
        </section>
        <Footer />
      </main>
    </div>
  );
};

export default App;
